import { createFileRoute } from '@tanstack/react-router';
import { SchedulesPage } from '@/pages/Cabinet/Schedules';
import { queryClient } from '@/app/providers/QueryProvider/client.ts';
import { fetchMediationsOptions } from '@/entities/mediation/api/fetchMediationsOptions.ts';

export const Route = createFileRoute('/_layout/cabinet/schedules')({
  component: SchedulesPage,
  loader: () => {
    return queryClient.fetchQuery(fetchMediationsOptions());
  },
});
